import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { HomeIcon, ArrowLeftIcon } from 'lucide-react';
export function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  return <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4" data-id="element-1949">
      <div className="text-8xl font-bold text-gray-200 select-none mb-2" data-id="element-1950">
        404
      </div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1951">Page not found</h1>
      <p className="text-gray-500 mb-1 max-w-md" data-id="element-1952">
        The page{' '}
        <code className="px-1.5 py-0.5 bg-gray-100 rounded text-sm text-gray-700" data-id="element-1953">
          {location.pathname}
        </code>{' '}
        doesn't exist or has been moved.
      </p>
      <p className="text-sm text-gray-400 mb-8" data-id="element-1954">
        Check the URL or head back to a familiar place.
      </p>
      <div className="flex items-center gap-3" data-id="element-1955">
        <Button variant="secondary" onClick={() => navigate(-1)} leftIcon={<ArrowLeftIcon className="w-4 h-4" data-id="element-1957" />} data-id="element-1956">
          Go Back
        </Button>
        <Button onClick={() => navigate('/')} leftIcon={<HomeIcon className="w-4 h-4" data-id="element-1959" />} data-id="element-1958">
          Dashboard
        </Button>
      </div>
    </div>;
}